import { render, staticRenderFns } from "./TvaSvgIcons.vue?vue&type=template&id=b200df16&scoped=true&"
var script = {}
import style0 from "./TvaSvgIcons.vue?vue&type=style&index=0&id=b200df16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b200df16",
  null
  
)

export default component.exports